import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
        flex: 1,
        paddingLeft: 25,
        paddingRight: 25,
        justifyContent: 'flex-start',
    },
    action_button: {
        padding: 10,
        borderRadius: 20,
    },
    action_button_text: {
        textTransform: "uppercase",
        fontWeight: "bold",
        color: "#FFF",
        textAlign: 'center'
    },
    card: {
        backgroundColor: '#fff',
        marginTop: 20,
        borderRadius: 10,
        height: 350
    },
    view: {  
        marginTop: 20,
    },
    frontCover: {
        width: '100%',
        height: 140,
        borderTopRightRadius: 10,
        borderTopLeftRadius: 10,
    },
    nameCategory: {
        position: 'absolute',
        marginTop: 110,
        textAlign: 'center',
        color: '#fff',
        fontWeight: 'bold',
        width: '100%',
    },
    contentDescription: {
        padding: 15,
        marginTop: 20
    },
    description: {
        textAlign: 'justify',
        fontSize: 12,
        fontWeight: '400',
        lineHeight: 16
    },
    contentBtn: {
        alignItems: 'center',
        width: '100%',
        bottom: 20,
        position: 'absolute'
    },
    btn: {
        padding: 10,
        borderRadius: 20,
        width: 200
    },
    textBtn: {
        color: '#fff',
        textAlign: 'center',
        fontSize: 14,
        fontWeight: '500',
    },
    label: {
        fontSize: 14,
        marginBottom: 10,
        marginTop: 20
    },
    input: {
        width: "90%",
        borderBottomWidth: 0.5
    },
});

export default styles;
